import { useState, useRef } from 'react';

export interface IServiceType {
  isOpenProject: number; // 是否存在项目 1：是，0：否
  serviceType: number; // 1：熟车下单，2：定制服务
  serviceStatus: number; // 1: 开通， 2： 关闭
}

/**
 * 不要使用这里的 serviceTypeList，这里只是存数据
 * 请通过 @/ahooks/use-service-type-list 使用 serviceTypeList
 */
export default function ServiceTypeList() {
  const [serviceTypeList, setServiceTypeList] = useState<IServiceType[]>([]);
  const isFetchedRef = useRef(false);

  return {
    serviceTypeList,
    setServiceTypeList,
    isFetchedRef, // 标识是已经有数据
  };
}
